import { graphql } from '@teachino/shared-infrastructure';

export const coursePublicAccessQuery = graphql(`
  query CoursePublicAccess($courseId: String!) {
    coursePublicAccess(courseIdInput: { id: $courseId }) {
      id
      code
    }
  }
`);
